var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.commendList.length > 0)?_c('div',{staticClass:"ui-recommend-wrapper"},[_c('div',{staticClass:"title"},[_vm._v("为你推荐")]),_c('div',{staticClass:"product-list-body"},_vm._l((_vm.commendList),function(item,index){return _c('index-product-body',{key:index,attrs:{"item":item,"index":index}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }